import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import QaiScorecardChallengeNoteViewModel from "./ViewModels/QaiScorecardChallengeNoteViewModel";

interface IQaiChallengeAddNoteProps {
    noteViewModel: QaiScorecardChallengeNoteViewModel
    setNoteViewModel: (value: QaiScorecardChallengeNoteViewModel) => void;
}

export default function QaiChallengeAddNote({ noteViewModel, setNoteViewModel }: IQaiChallengeAddNoteProps) {
    const noteOnChangeHandler = (e: any) => {
        setNoteViewModel({
            ...noteViewModel,
            note: e.target.value
        })
    }

    return (
        <Grid height="26%" size={12} border="solid 1px rgb(192, 192, 192)" borderRadius="4px" sx={{ backgroundColor: '#f5f5f5' }}>
            <TextField
                id="note"
                onChange={noteOnChangeHandler}
                value={noteViewModel.note}
                fullWidth
                multiline
                rows={8}
                placeholder="Add a note..."
                sx={{
                    "& fieldset": { border: 'none' },
                }} />
        </Grid>
    )
}